import GatsbyImageWrapper from "../../GatsbyImageWrapper";

import React, { useContext, useEffect } from "react";

import { usePageLocalization } from "@sbi-international/boutik.gatsby.plugin.multilocale";
import { IProduct, ServicesContext } from "@sbi-international/boutik.gatsby.plugin.services";
import { popFrontURL } from "../../../utils/popFrontURL";
import { AllProductsNodeModel } from "../../../models/allProductsNodeModel";
import { ProductPrice, ProductStock } from "@sbi-international/boutik.gatsby.plugin.components";

export function AccessorySingle(props: { product: AllProductsNodeModel }) {
    const { product } = props;
    const { navigateTranslated, currentLocale } = usePageLocalization();

    const servicesContext = useContext(ServicesContext);
    const productService = servicesContext?.magento.productService;

    const navigateToAccessory = (product: AllProductsNodeModel) => {
        if (product) {
            const link = popFrontURL(product?.static?.slug?.[currentLocale], 1);

            if (link) {
                navigateTranslated(link);
            }
        }
    };

    useEffect(() => {
        if (product && product?.live == null) {
            productService.operations.getProduct(product.static.code ?? "").then((productLive) => {
                if (productLive) {
                    product.live = productLive;
                }
            });
        }
    }, [product]);

    return (
        <>
            <div
                className="product search-accessories"
                onClick={() => {
                    navigateToAccessory(product);
                }}
            >
                <div className="product-image">
                    <GatsbyImageWrapper fields={product.static.fields} />
                </div>
                <div className="product-info">
                    <span className="code">{product.static.code}</span>
                    <span className="title">{product?.static.title?.[currentLocale]}</span>{" "}
                    {product?.live?.currentStock?.status !== "discontinued" && (
                        <>
                            <ProductPrice
                                currentPrice={product?.live?.currentPrice}
                                prefixClassName="listing-accessory-single"
                            />
                            <ProductStock
                                currentStock={product?.live?.currentStock}
                                type="small"
                                isCustomMade={false}
                            />
                        </>
                    )}
                </div>
            </div>
        </>
    );
}
